import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useSetState } from 'ahooks'
import {
  SActionBtn,
  SBack,
  SDrawerOrModal,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { Button, message, Upload } from 'antd'

import {
  deletedBatchByIds,
  generalStandardDelete,
  generalStandardImportFile,
  generalStandardSave,
  generalStandardUpdateById,
  getGeneralStandardPage,
  getProductCommonPage,
  saveBatchList,
} from '@/services/product.ts'
import { config } from './config.tsx'
import { AddOrEditStandard } from './addOrEdit.tsx'
import { useParams, useSearchParams } from 'react-router-dom'
import { apiData2Table } from '@/utils/data.ts'
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import { httpOrgList } from '@/services/homeService.ts'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import styles from './index.module.less'
export const StandardTable = forwardRef((props, ref) => {
  const { genItemId } = useParams()
  const [searchParams] = useSearchParams({})
  const readOnly = searchParams.get('readOnly')
  const itemName = searchParams.get('itemName')
  const specialCode = searchParams.get('specialCode')
  console.log(itemName)
  console.log(specialCode)

  const listRef = useRef()
  const editRef = useRef()

  const [state, setState] = useSetState({
    visible: false,
    record: {},
    btnLoading: false,
    exportLoading: false,
    importLoading: false,
    loading: false,
    companyList: [],
  })

  useImperativeHandle(ref, () => {
    return { getData: () => listRef.current?.getDataSource() }
  })
  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      console.log(query)
      query.genItemId = genItemId
      query.orderBys = [
        {
          columnName: 'id',
          asc: false,
        },
      ]
      query.searchFlag = true
      getGeneralStandardPage({
        params: { pageId: current, pageSize },
        data: { ...query },
      })
        .then(res => {
          res.list = res.list?.map((item, index) => {
            return {
              ...item,
              orderNumber: index + 1,
            }
          })
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    setState({ visible: true, record })
  }

  const onDel = record => {
    SMessage.confirm({
      onOk: () => {
        if (!genItemId) {
          const data = listRef.current?.getDataSource()
          listRef.current?.updateDataSource(data.filter(item => item.key !== record.key))
          return Promise.resolve()
        } else {
          return generalStandardDelete(record.id).then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
          })
        }
      },
    })
  }
  const onImport = (upload: any) => {
    setState({ importLoading: true })
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    data.append('genStandId', genItemId)
    return generalStandardImportFile(data)
      .then((res: any) => {
        listRef.current && listRef.current.reload()
        onSuccess && onSuccess()
        message.success(res.message || '导入成功')
      })
      .catch(onError)
      .finally(() => setState({ importLoading: false }))
  }

  const onExport = () => {
    setState({ exportLoading: true })
    fileDownload(UrlConfig.PlusProductWeb.GeneralStandardExportFile)
      .then(() => setState({ exportLoading: false }))
      .catch(() => setState({ exportLoading: false }))
  }
  const getOptions = () => {
    return new Promise(async (resolve, reject) => {
      const companyList: any = await httpOrgList()
      resolve({
        companyList: [{ name: '通用', id: '0' }, ...companyList],
      })
    })
  }
  const onBatchDelete = ({ selectedRowKeys }) => {
    SMessage.confirm({
      content: `是否确认删除所选数据`,
      onOk: () => {
        return deletedBatchByIds({ data: { idList: selectedRowKeys, enabled: true } }).then(
          (res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
          }
        )
      },
    })
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: { onAdd, onBatchDelete },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {!readOnly && [
              <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>,
              <SActionBtn danger onClick={() => onDel(record)}>
                删除
              </SActionBtn>,
            ]}
          </STableActions>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={state.importLoading}
              disabled={state.importLoading}
              icon={<UploadOutlined />}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
            disabled={state.exportLoading}
            loading={state.exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
      productRender: ({ name, form }) => {
        return (
          <DebounceSelect
            allowClear
            label={'产品'}
            isCommon={true}
            style={{ width: '100%' }}
            onChange={v => {
              form.setFieldsValue({ [name]: v })
            }}
            fixedParams={{ prodType: 'PRODUCT_PACKAGE' }}
            fetchOptions={getProductCommonPage}
            fieldNames={{ label: 'prodName', value: 'id' }}
          />
        )
      },
    },
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const onSubmit = () => {
    editRef.current?.onFinish()
  }

  const onSubmitOk = values => {
    const apiUrl = values.id ? generalStandardUpdateById : saveBatchList
    apiUrl(values)
      .then((res: any) => {
        message.success(res.message || '操作成功')
        listRef.current?.reload()
        onCancel()
      })
      .catch(() => {
        setState({ btnLoading: false })
      })
      .finally(() => { 
        setState({ btnLoading: false })
      })
  }
  const showTitle = () => {
    if (itemName || specialCode) {
      return `标配 （${itemName || ''}${specialCode&&specialCode!=='undefined' ? '-' : ''}${specialCode&&specialCode!=='undefined' ? specialCode : ''}）`
    }
    return '标配'
  }
  const rowClassName = (record: any) => {
    console.log(record);
    const skuShopIds  = record?.productSku?.shopIds
    const selfShopsId  = record?.orgId
    if (skuShopIds.includes('0')) {
      return ''
    }else if (skuShopIds.includes(selfShopsId)){
      return ''
    }else{
      return 'error-class'
    }
  }
  return (
    <SBack title={showTitle()} level={2}>
      <div className={styles.standardBox}>
        <SLowcodeList
          searchMode={'group'}
          ref={listRef}
          config={{ ...config, footer: readOnly ? [] : config.footer }}
          {...extensions}
          rowClassName={rowClassName}
        />
        <SDrawerOrModal
          title={readOnly ? '标配详情' : (state.record?.id ? '编辑' : '新增') + '标配'}
          width={600}
          open={state.visible}
          onOk={onSubmit}
          antdProps={readOnly ? { footer: null } : {}}
          loading={state.btnLoading}
          onCancel={onCancel}
        >
          {state.visible && (
            <AddOrEditStandard
              record={state.record}
              ref={editRef}
              genItemId={genItemId}
              fn={onSubmitOk}
              setLoading={(btnLoading: boolean) => setState({ btnLoading })}
            />
          )}
        </SDrawerOrModal>
      </div>
    </SBack>
  )
})
